import React from "react";

import DisplayValue from "@/components/generic/DisplayValue";
import { PAYMENT_TYPES } from "@/util/common";
import { SEMI_BOLD } from "@/constants/fonts";

import { Text, Box, Stack, Switcher, CardType } from "@thecb/components";

const maskBin = (isExternal, firstSix) => isExternal || (firstSix ?? "******");

const getMaskedCardNumber = (card, isExternal, unavailableMessage) => {
  if (card?.firstSix?.value && card?.lastFour?.value)
    return `${maskBin(isExternal, card.firstSix.value)}******${card.lastFour.value}`;
  return unavailableMessage;
};

const getFormattedExpirationDate = (card, isExternal, unavailableMessage) => {
  if (card?.expMonth?.value && card?.expYear?.value && !isExternal)
    return `${card.expMonth.value}/${card.expYear.value}`;
  return unavailableMessage;
};

export default ({ creditCard, paymentType, specificParams }) => {
  const isExternal =
    paymentType === PAYMENT_TYPES.EXT_CARD ||
    paymentType === PAYMENT_TYPES.EXT_READ_CARD;
  const unavailableMessage = "Not available";

  const type = creditCard?.type?.value;
  const cardNumber = getMaskedCardNumber(creditCard, isExternal, unavailableMessage);
  const cardholderName = creditCard?.cardholderName?.value ?? unavailableMessage;
  const expirationDate = getFormattedExpirationDate(
    creditCard,
    isExternal,
    unavailableMessage
  );
  const zipCode = creditCard?.zipCode?.value ?? unavailableMessage;
  const emailAddress = specificParams?.emailAddress?.value ?? unavailableMessage;

  return (
    <Stack childGap="0.5rem">
      <DisplayValue title="Payment method type" value={paymentType} />
      <Switcher
        breakpoint="700px"
        childGap="0.25rem"
        largeChild={2}
        largeChildSize={5}
      >
        <Text variant="pS" weight={SEMI_BOLD} extraStyles="flex-basis: 17rem;">
          Payment method
        </Text>
        <Box padding="0" extraStyles="display: flex; align-items: center;">
          <CardType type={type} />
          <Text variant="pS" extraStyles="padding-left: 0.5rem;">
            {cardNumber}
          </Text>
        </Box>
      </Switcher>
      <DisplayValue title="Name" value={cardholderName} />
      <DisplayValue title="Expiration date" value={expirationDate} />
      <DisplayValue title="Zip code" value={zipCode} />
      <DisplayValue title="Receipt email address" value={emailAddress} />
    </Stack>
  );
};
